// local imports
import { lightGrey } from '~/colors'

export default {
    imageContainer: {
        position: 'relative',
        height: 380,
        width: '100%',
        marginBottom: 8
    },
    image: {
        backgroundColor: lightGrey,
        height: 380,
        width: '100%',
        transition: 'opacity 0.5s ease-in-out',
        backgroundSize: 'cover',
        position: 'absolute',
        top: 0,
        left: 0
    }
}



// WEBPACK FOOTER //
// ./src/components/Slideshow/styles.js